import baseURL from "../baseUrl";

export const useDeleteData = async (url, params) => {
  const token = localStorage.getItem("token"); // or from res.data.token
  const lang = localStorage.getItem("language") || "en";

  const headers = {
    Authorization: token ? `Bearer ${token}` : "",
    Accept: "application/json",
    lang: lang,
  };
  const res = await baseURL.delete(url, { headers, params });
  // const res = await baseURL.delete(url, { ...config, headers, params });
  return res.data;
};
